import { render, staticRenderFns } from "./settingData-add-or-update.vue?vue&type=template&id=0d1033c2&scoped=true&"
import script from "./settingData-add-or-update.vue?vue&type=script&lang=js&"
export * from "./settingData-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./settingData-add-or-update.vue?vue&type=style&index=0&id=0d1033c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1033c2",
  null
  
)

export default component.exports